import { render, staticRenderFns } from "./CreateAffiliateList.vue?vue&type=template&id=d0ad68d4"
import script from "./CreateAffiliateList.vue?vue&type=script&lang=ts"
export * from "./CreateAffiliateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports